import { useEffect, useRef, useState } from "react";

export default function ShareMenu() {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast(`复制失败，请手动复制：${url}`);
    }
  };

  const share = (platform: string) => {
    setToast(`已打开${platform}分享（演示效果）`);
    setOpen(false);
  };

  return (
    <div className="relative" ref={wrapRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
      >
        <i className="ri-share-line text-lg"></i>
        分享
      </button>

      {open && (
        <div className="absolute left-0 top-full z-30 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <button
            type="button"
            onClick={copyLink}
            className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-link text-lg"></i>
            复制链接
          </button>
          <button
            type="button"
            onClick={() => share("微信")}
            className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-wechat-line text-lg"></i>
            分享到微信
          </button>
          <button
            type="button"
            onClick={() => share("微博")}
            className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-weibo-line text-lg"></i>
            分享到微博
          </button>
        </div>
      )}

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 animate-fade-in rounded-md bg-foreground-950 px-5 py-3 text-sm text-background-50">
          {toast}
        </div>
      )}
    </div>
  );
}